import { Accordion, Button, Combobox, createTheme, Input, InputBase, Overlay, PillsInput, rem } from "@mantine/core"



const mantineTheme = createTheme({
    /** Put your mantine theme override here */
    colors: {
        gray: [
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#364152",
            "#333C46",
            "#344054",
            "#3D3D3D"
        ],
        primary: [
            "#F57F22",
            "#F67F00",
            "#F57F22",
            "#F57F22",
            "#F57F22",
            "#F57F22",
            "#F57F22",
            "#F57F22",
            "#F57F22",
            "#F57F22",
        ],
        blue: [
            "#0010F6",
            "#0230A2",
            "#0010F6",
            "#0010F6",
            "#0010F6",
            "#0010F6",
            "#0010F6",
            "#0010F6",
            "#0010F6",
            "#0010F6",
        ],
        success: [
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
            "#1D7225",
        ]
    },
    breakpoints: {
        sm: "769px"
    },
    fontFamily: "IRANSans",
    components: {
        Combobox: Combobox.extend({
            defaultProps: {
                styles: {
                    dropdown: {
                        borderRadius: "8px",
                    }
                }
            }
        }),
        PillsInput: PillsInput.extend({
            defaultProps: {
                styles: {
                    label: {
                        fontSize: rem(14),
                        fontWeight: 500,
                        lineHeight: rem(20),
                        paddingBottom: rem(6)
                    }
                }
            }
        }),
        InputBase: InputBase.extend({
            defaultProps: {
                fz: { base: rem(12), sm: rem(14) },
                fw: 300,
                lh: { base: rem(18), sm: rem(21) },
                styles: {
                    input: {
                        background: "#F9F9F9",
                        border: "none",
                        borderRadius: rem(8),
                        lineHeight: rem(24),
                        paddingBlock: rem(24),
                        "&::placeholder": {
                            color: "#D9D9D9"
                        }
                    },
                }
            }
        }),
        Button: Button.extend({
            defaultProps: {
                color: "primary",
                radius: rem(8),
                fz: rem(16),
                fw: 500,
                lh: rem(24),
                py: 8,
                px: 14,
                h: "unset"
            }
        }),
        Input: Input.extend({
            defaultProps: {
                fz: { base: rem(12), sm: rem(14) },
                fw: 300,
                lh: { base: rem(18), sm: rem(21) },
                styles: {
                    input: {
                        background: "#F9F9F9",
                        border: "none",
                        borderRadius: rem(8),
                        lineHeight: rem(24),
                        paddingBlock: rem(24),
                        "&::placeholder": {
                            color: "#D9D9D9"
                        }
                    },
                }
            }
        }),
        InputWrapper: Input.Wrapper.extend({
            defaultProps: {
                c: "#707070",
                fw: 400,
                fz: { base: rem(12), sm: rem(14) },
                lh: { base: rem(18), sm: rem(21) },
                styles: {
                    label: {
                        marginBottom: rem(10),
                    }
                }
            }
        }),
        Overlay: Overlay.extend({
            defaultProps: {
                zIndex: 10
            }
        }),
        Accordion: Accordion.extend({
            defaultProps: {
                variant: "separated",
                chevronSize: 32,
                styles: {
                    item: {
                        background: "white",
                        borderRadius: 16,
                        border: "none",
                        paddingBlock: "12px"
                    },
                    control: {
                        paddingBlock: "6px",
                    },
                    chevron: {
                        color: "orange",
                    },
                }
            }
        })
    }
});

export default mantineTheme